import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { RoleGuard } from './core/auth/guards/role.guard';
import { AdminGuard } from './core/auth/guards/admin.guard';
import { CanViewSaleGuard } from './core/auth/guards/can-view-sale.guard';
import { CanAccessFinanceGuard } from './core/auth/guards/can-access-finance.guard';
import { CanAccessClientsGuard } from './core/auth/guards/can-access-clients.guard';
import { CanAccessCarriersGuard } from './core/auth/guards/can-access-carriers.guard';
import { CanAccessSuppliersGuard } from './core/auth/guards/can-access-suppliers.guard';
import { CanAccessProductsGuard } from './core/auth/guards/can-access-products.guard';
import { CanAccessWalletGuard } from './core/auth/guards/can-access-wallet.guard';
import { CanAccessCrmGuard } from './core/auth/guards/can-access-crm.guard';
import { CanAccessNfeGuard } from './core/auth/guards/can-access-nfe.guard';
import { CanAccessUsersGuard } from './core/auth/guards/can-access-users.guard';
// import { profilesTypes, profileTypeStrategies } from './models/user.model';
// const profilesRoutes = profilesTypes
//     .filter((e) => e != 'PATIENT')
//     .map((type) => {
//         return {
//             path: `access/${profileTypeStrategies[type].toLowerCase()}`,
//             canActivate: [RoleGuard],
//             canActivateChild: [RoleGuard],
//             data: {
//                 // functions: ['pcp_enabled', 'can_write_clients'],
//                 config_screen: {
//                     type: type,
//                 },
//             },
//             loadChildren: () => import('app/modules/configurations/access/user/user.routes'),
//         };
//     });
// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
    // Redirect empty path to '/example'
    { path: '', pathMatch: 'full', redirectTo: 'wallet' },

    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'not-found-company', loadChildren: () => import('app/modules/auth/not-found-company/not-found-company.routes') },

    // Reset password route (no guard protection)
    {
        path: 'auth/reset-password',
        loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes'),
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
    },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            { path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes') },
            { path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes') },
            { path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes') },
            { path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes') },
        ],
    },

    // Public routes (acessíveis por qualquer pessoa, com ou sem autenticação)
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            { path: 'contract/sign/:token', loadChildren: () => import('app/modules/contract-sign/contract-sign.routes') },
            { path: 'document/sign/:token', loadChildren: () => import('app/modules/document-sign/document-sign.routes') },
            { path: 'sale/sign/:token', loadChildren: () => import('app/modules/sale-sign/sale-sign.routes') },
        ],
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            { path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes') },
            { path: 'change-password', loadChildren: () => import('app/modules/auth/change-password/change-password.routes') },
            { path: 'file-viewer', loadChildren: () => import('app/modules/file-viewer/file-viewer.routes') },
            // { path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes') },
        ],
    },
    // // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],       
        canActivateChild: [AuthGuard],
component: LayoutComponent,                                                                                                                                                                                                                                                                                                                                                                                                                 
        resolve: {
            initialData: initialDataResolver,
        },
        children: [
            // Carteira
            {
                path: 'wallet',        
                canActivate: [CanAccessWalletGuard],
                canActivateChild: [CanAccessWalletGuard],                                             
                loadChildren: () => import('app/modules/wallet/wallet.routes'),
            },

            // Produções
            {
                path: 'productions',
                loadChildren: () => import('app/modules/production_order_sale/production_order_sale.routes'),
            },

            // CRM
            {
                path: 'crm',
                canActivate: [CanAccessCrmGuard],
                canActivateChild: [CanAccessCrmGuard],
                loadChildren: () => import('app/modules/crm/crm.routes'),
            },

            // Vendas e Orçamentos
            {
                path: 'sales',
                canActivate: [CanViewSaleGuard],
                canActivateChild: [CanViewSaleGuard],
                loadChildren: () => import('app/modules/sale/sale.routes'),
            },

            // Financeiro
            {
                path: 'finance',
                canActivate: [CanAccessFinanceGuard],
                canActivateChild: [CanAccessFinanceGuard],
                loadChildren: () => import('app/modules/finance/finance.routes'),
            },

            // Nota Fiscal
            {
                path: 'nfe',
                canActivate: [CanAccessNfeGuard],
                canActivateChild: [CanAccessNfeGuard],
                loadChildren: () => import('app/modules/nfe/nfe.routes'),
            },

            // Clientes
            {
                path: 'clients',
                canActivate: [CanAccessClientsGuard],
                canActivateChild: [CanAccessClientsGuard],
                loadChildren: () => import('app/modules/clients/clients.routes'),
            },

            // Transportadoras
            {
                path: 'carriers',
                canActivate: [CanAccessCarriersGuard],
                canActivateChild: [CanAccessCarriersGuard],
                loadChildren: () => import('app/modules/carriers/carriers.routes'),
            },

            // Fornecedores
            {
                path: 'suppliers',
                canActivate: [CanAccessSuppliersGuard],
                canActivateChild: [CanAccessSuppliersGuard],
                loadChildren: () => import('app/modules/suppliers/suppliers.routes'),
            },

            // Relatórios
            {
                path: 'reports',
                canActivate: [AdminGuard],
                canActivateChild: [AdminGuard],
                loadChildren: () => import('app/modules/reports/reports.routes'),
            },

            // Produtos (mover para fora de Configurações)
            {
                path: 'products',
                canActivate: [CanAccessProductsGuard],
                canActivateChild: [CanAccessProductsGuard],
                loadChildren: () => import('app/modules/configurations/product/product.routes'),
            },

            // Usuários (fora de Configurações)
            {
                path: 'users',
                canActivate: [CanAccessUsersGuard],
                canActivateChild: [CanAccessUsersGuard],
                loadChildren: () => import('app/modules/configurations/user/user.routes'),
            },

            // Configurações - Funções
            {
                path: 'configuration/permissons',
                canActivate: [AdminGuard],
                canActivateChild: [AdminGuard],
                loadChildren: () => import('app/modules/configurations/permission/permission.routes'),
            },

            // Configurações - Produtos (oculto no menu principal)
            // Mantido por compatibilidade de rota antiga (se necessário)

            // Configurações - Tipos de Produtos
            {
                path: 'configuration/type_product',
                canActivate: [AdminGuard],
                canActivateChild: [AdminGuard],
                loadChildren: () => import('app/modules/configurations/type_product/type_product.routes'),
            },

            // Configurações - Ferramentas de Prospecção
            {
                path: 'configuration/prospection_tool',
                canActivate: [AdminGuard],
                canActivateChild: [AdminGuard],
                loadChildren: () => import('app/modules/configurations/prospection_tool/prospection_tool.routes'),
            },

            // Configurações - Status de Ordem de Produção
            {
                path: 'configuration/status-order',
                canActivate: [AdminGuard],
                canActivateChild: [AdminGuard],
                loadChildren: () => import('app/modules/configurations/status_production_order/status_production_order.routes'),
            },

            // Configurações - Empresas
            {
                path: 'configuration/companies',
                canActivate: [AdminGuard],
                canActivateChild: [AdminGuard],
                loadChildren: () => import('app/modules/company/company.routes'),
            },

            // Configurações - Contas Financeiras
            {
                path: 'configuration/financial-account',
                canActivate: [AdminGuard],
                canActivateChild: [AdminGuard],
                loadChildren: () => import('app/modules/configurations/financial_account/financial_account.routes'),
            },

            // Configurações - Integrações (WhatsApp)
            {
                path: 'configuration/integrations',
                canActivate: [AdminGuard],
                canActivateChild: [AdminGuard],
                loadChildren: () => import('app/modules/configurations/integrations/integrations.routes'),
            },

            // Rota de fallback
            { path: '**', redirectTo: 'wallet' },
        ],
    },
];
